import {Injectable} from '@angular/core';
import {ViewerTool} from '@app/viewer/viewable.interface';
import {Observable, ReplaySubject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ViewerToolsService {
    private _toolsSubject: ReplaySubject<ViewerTool[]>;
    public tools$: Observable<ViewerTool[]>;

    constructor() {
        this._toolsSubject = new ReplaySubject<ViewerTool[]>(1);
        this.tools$ = this._toolsSubject.asObservable();
    }

    setTools(tools: ViewerTool[]) {
        this._toolsSubject.next(tools);
    }
}
